import axios from "axios";
import { StudyCreatePayload, StudyDataType } from "@/types/apiTypes";
import { API_BASE_URL } from "@/utils/api";
import { getToken } from "@/utils/authHelpers";

export const createStudyApi = async (
  studyData: StudyCreatePayload,
): Promise<StudyDataType> => {
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");
  const response = await axios.post<StudyDataType>(
    `${API_BASE_URL}/save-study`,
    studyData,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};
